export interface Transaction {
  company: string;
  description: string;
}

export interface TeamMember {
  id: string;
  name: string;
  title: string;
  location: string;
  phone?: string;
  address?: {
    building: string;
    level: string;
    street: string;
    city: string;
    state: string;
    postcode: string;
    country: string;
  };
  description: string;
  background: string;
  experience: string;
  qualifications: string;
  transactions: Transaction[];
  image?: string;
  imageStyle?: {
    scale?: number;
    objectPosition?: string;
  };
}

export const teamMembers: TeamMember[] = [
  {
    id: "stephen-chipfunde",
    name: "Stephen Chipfunde",
    title: "Advisory Board Chair",
    location: "Sydney",
    description: "Stephen is the Advisory Board Chair at Mercurian Equity and the Managing Principal of Mercurian Equity Pty Ltd. Stephen is an experienced corporate strategist and operations improvement specialist.",
    background: "In this role, he sets and drives the strategic goals of the company, investment framework and oversees day to day management of the firm.",
    experience: "He has experience in private markets, with a primary focus on driving operational efficiency across a variety of businesses and industries in Australia.",
    qualifications: "Stephen holds a postgrad in Corporate Finance from Wharton, an MBA (Strategy & Finance) from Curtin Graduate School of Business and a Bachelor of Engineering (Chemical) from Curtin University. He is also a Graduate from the Australian Institute of Company Directors.",
    transactions: []
  },
  {
    id: "lincoln-pan",
    name: "Lincoln Pan",
    title: "Advisory Board Member",
    location: "Sydney",
    description: "Lincoln Pan is an Advisory Board Member at Mercurian Equity and a member of the Investment Committee. In this role, he supports development of the strategic goals of the company and investment execution.",
    background: "Lincoln is a dynamic entrepreneur with over a decade of experience in the financial sector. He's recognised as a financial specialist and trusted adviser to sophisticated investors.",
    experience: "He has an extensive business network across Asia-pacific and a proven track record in delivering high-complexity operations across various market conditions.",
    qualifications: "Lincoln holds a Bachelor of Commerce (Accounting & Finance) and MBA (Finance & Leadership) from The University of Western Australia and Executive Education from Harvard Business School. Lincoln is also a fellow of the Institute of Public Accountants and a professional member of the Australian Institute of Company Directors.",
    transactions: [],
    image: "/photo/lincoln-pan-web.jpg"
  },
  {
    id: "hao-zeng",
    name: "Hao Zeng",
    title: "Advisory Board Member",
    location: "Sydney",
    description: "Hao is an Advisory Board Member at Mercurian Equity and a member of the Investment Committee.",
    background: "Hao brings years of experience in corporate advisory, funds management and global business strategy execution.",
    experience: "Over the years, Hao has developed expertise in providing capital market services for real estate and mining companies with large equity portfolios, operating in the mid to upper markets.",
    qualifications: "Hao holds a Bachelor of Economics and a Graduate Certificate of Commerce from the University of Queensland.",
    transactions: [],
    image: "/photo/IMG_6435.jpg",
    imageStyle: {
      scale: 1.5,
      objectPosition: "center 90%"
    }
  },
  {
    id: "hector-wu",
    name: "Hector Wu",
    title: "Advisory Board Member",
    location: "Sydney",
    description: "Hector is an Advisory Board Member at Mercurian Equity and a member of the Investment Committee.",
    background: "In this role, Hector is responsible for overseeing and enhancing Mercurian Equity's risk capability to support a continued focus on serving investors and their advisors.",
    experience: "Hector is a seasoned business executive specialising in Corporate Governance & Risk Management. His unique and systematic approach fosters growth and expansion of businesses from inception to scale.",
    qualifications: "He holds a Master of Professional Accounting from the Australian National University and a Master of International Business from the University of Wollongong. He is a professional member of the Certified Practicing Accountant (CPA).",
    transactions: [],
    image: "/photo/hector-wu-web.jpg"
  }
];